export const saveStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (e) {
    return false;
  }
};

export const removeStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

export const getStorage = (key) => {
  try {
    const cookie = localStorage.getItem(key);
    const parsed = JSON.parse(cookie);
    return parsed;
  } catch (e) {
    return null;
  }
};
